import { render, staticRenderFns } from "./CongratulationsTalent.vue?vue&type=template&id=2fffef6a&scoped=true"
import script from "./CongratulationsTalent.vue?vue&type=script&lang=js"
export * from "./CongratulationsTalent.vue?vue&type=script&lang=js"
import style0 from "./CongratulationsTalent.vue?vue&type=style&index=0&id=2fffef6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffef6a",
  null
  
)

export default component.exports